import { Typography } from 'antd';
import styled from 'styled-components';

interface FlexWrapperProps {
  color?: string;
}

const FlexWrapper = styled.div<FlexWrapperProps>`
  color: ${(props) => props.color ?? 'currentColor'};
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 16px;
  padding: 8px 0;
  width: calc(100% - 32px);
  height: 66px;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  color: currentColor;

  span {
    color: currentColor;
  }

  h5 {
    color: currentColor;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled(Typography.Title)`
  margin-bottom: 0 !important;
  color: currentColor;
`;

export { FlexWrapper, IconWrapper, TextWrapper, Title };
